/* tslint:disable */
/* eslint-disable */
/**
 * WebCore
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BCCADMINBaseModelsBrokenLinkScanResult } from '../Models';
// @ts-ignore
import type { BCCADMINBaseModelsContentTypeIdForceResult } from '../Models';
// @ts-ignore
import type { BCCADMINBaseModelsDanglingReferencePruneResult } from '../Models';
// @ts-ignore
import type { BCCADMINBaseModelsDeployedFileRepairResult } from '../Models';
// @ts-ignore
import type { BCCADMINBaseModelsDeployedFileScanResult } from '../Models';
// @ts-ignore
import type { BCCADMINBaseModelsDeploymentQueueSeedResult } from '../Models';
// @ts-ignore
import type { BCCADMINBaseModelsDynamicPathRefreshResult } from '../Models';
// @ts-ignore
import type { BCCADMINBaseModelsDynamicPathScanResult } from '../Models';
// @ts-ignore
import type { BCCADMINBaseModelsReferenceIdForceReport } from '../Models';
// @ts-ignore
import type { BCCADMINBaseModelsReferenceIdForceResult } from '../Models';
// @ts-ignore
import type { BCCADMINServicesReferenceDataReferenceDataReconcileReport } from '../Models';
// @ts-ignore
import type { BCCADMINServicesServicesSmartReconcileResult } from '../Models';
/**
 * AdminApi - axios parameter creator
 */
export const AdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} target 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminDeployedFilesRepairTargetPost: async (target: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'target' is not null or undefined
            assertParamExists('apiAdminDeployedFilesRepairTargetPost', 'target', target)
            const localVarPath = `/api/admin/deployed-files/repair/{target}`
                .replace('{target}', encodeURIComponent(String(target)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} target 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminDeployedFilesScanTargetPost: async (target: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'target' is not null or undefined
            assertParamExists('apiAdminDeployedFilesScanTargetPost', 'target', target)
            const localVarPath = `/api/admin/deployed-files/scan/{target}`
                .replace('{target}', encodeURIComponent(String(target)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminDeploymentQueueForcePreviewPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/deployment-queue/force-preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminDeploymentQueueSeedPreviewPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/deployment-queue/seed-preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminLinksScanPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/links/scan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminMaintenanceForceCategoryIdsPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/maintenance/force-category-ids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminMaintenanceForceContentTypeIdsPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/maintenance/force-content-type-ids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminMaintenanceForceReferenceDataIdsPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/maintenance/force-reference-data-ids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminMaintenanceForceTaxonomyIdsPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/maintenance/force-taxonomy-ids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminMaintenanceHardCleanStatusGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/maintenance/hard-clean/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} target 
         * @param {boolean} [purge] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminMaintenanceHardCleanTargetPost: async (target: string, purge?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'target' is not null or undefined
            assertParamExists('apiAdminMaintenanceHardCleanTargetPost', 'target', target)
            const localVarPath = `/api/admin/maintenance/hard-clean/{target}`
                .replace('{target}', encodeURIComponent(String(target)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (purge !== undefined) {
                localVarQueryParameter['purge'] = purge;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [dryRun] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminMaintenanceMigrateBodiesPost: async (dryRun?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/maintenance/migrate-bodies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (dryRun !== undefined) {
                localVarQueryParameter['dryRun'] = dryRun;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminMaintenanceMigrateBodiesStatusGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/maintenance/migrate-bodies/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminMaintenancePruneDanglingReferenceRefsPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/maintenance/prune-dangling-reference-refs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} target 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminMaintenanceRebakeFragmentsTargetPost: async (target: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'target' is not null or undefined
            assertParamExists('apiAdminMaintenanceRebakeFragmentsTargetPost', 'target', target)
            const localVarPath = `/api/admin/maintenance/rebake-fragments/{target}`
                .replace('{target}', encodeURIComponent(String(target)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [pruneContentTypes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminMaintenanceReconcileReferenceDataPost: async (pruneContentTypes?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/maintenance/reconcile-reference-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pruneContentTypes !== undefined) {
                localVarQueryParameter['pruneContentTypes'] = pruneContentTypes;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminMaintenanceRetranslateAllPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/maintenance/retranslate-all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminMaintenanceSmartReconcilePost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/maintenance/smart-reconcile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminRefreshDynamicPathsPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/refresh-dynamic-paths`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminScanDynamicPathsPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/scan-dynamic-paths`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminApi - functional programming interface
 */
export const AdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} target 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminDeployedFilesRepairTargetPost(target: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BCCADMINBaseModelsDeployedFileRepairResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminDeployedFilesRepairTargetPost(target, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.apiAdminDeployedFilesRepairTargetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} target 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminDeployedFilesScanTargetPost(target: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BCCADMINBaseModelsDeployedFileScanResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminDeployedFilesScanTargetPost(target, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.apiAdminDeployedFilesScanTargetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminDeploymentQueueForcePreviewPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BCCADMINBaseModelsDeploymentQueueSeedResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminDeploymentQueueForcePreviewPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.apiAdminDeploymentQueueForcePreviewPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminDeploymentQueueSeedPreviewPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BCCADMINBaseModelsDeploymentQueueSeedResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminDeploymentQueueSeedPreviewPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.apiAdminDeploymentQueueSeedPreviewPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminLinksScanPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BCCADMINBaseModelsBrokenLinkScanResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminLinksScanPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.apiAdminLinksScanPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminMaintenanceForceCategoryIdsPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BCCADMINBaseModelsReferenceIdForceResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminMaintenanceForceCategoryIdsPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.apiAdminMaintenanceForceCategoryIdsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminMaintenanceForceContentTypeIdsPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BCCADMINBaseModelsContentTypeIdForceResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminMaintenanceForceContentTypeIdsPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.apiAdminMaintenanceForceContentTypeIdsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminMaintenanceForceReferenceDataIdsPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BCCADMINBaseModelsReferenceIdForceReport>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminMaintenanceForceReferenceDataIdsPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.apiAdminMaintenanceForceReferenceDataIdsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminMaintenanceForceTaxonomyIdsPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BCCADMINBaseModelsReferenceIdForceResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminMaintenanceForceTaxonomyIdsPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.apiAdminMaintenanceForceTaxonomyIdsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminMaintenanceHardCleanStatusGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminMaintenanceHardCleanStatusGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.apiAdminMaintenanceHardCleanStatusGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} target 
         * @param {boolean} [purge] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminMaintenanceHardCleanTargetPost(target: string, purge?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminMaintenanceHardCleanTargetPost(target, purge, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.apiAdminMaintenanceHardCleanTargetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean} [dryRun] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminMaintenanceMigrateBodiesPost(dryRun?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminMaintenanceMigrateBodiesPost(dryRun, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.apiAdminMaintenanceMigrateBodiesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminMaintenanceMigrateBodiesStatusGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminMaintenanceMigrateBodiesStatusGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.apiAdminMaintenanceMigrateBodiesStatusGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminMaintenancePruneDanglingReferenceRefsPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BCCADMINBaseModelsDanglingReferencePruneResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminMaintenancePruneDanglingReferenceRefsPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.apiAdminMaintenancePruneDanglingReferenceRefsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} target 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminMaintenanceRebakeFragmentsTargetPost(target: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminMaintenanceRebakeFragmentsTargetPost(target, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.apiAdminMaintenanceRebakeFragmentsTargetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean} [pruneContentTypes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminMaintenanceReconcileReferenceDataPost(pruneContentTypes?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BCCADMINServicesReferenceDataReferenceDataReconcileReport>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminMaintenanceReconcileReferenceDataPost(pruneContentTypes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.apiAdminMaintenanceReconcileReferenceDataPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminMaintenanceRetranslateAllPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminMaintenanceRetranslateAllPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.apiAdminMaintenanceRetranslateAllPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminMaintenanceSmartReconcilePost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BCCADMINServicesServicesSmartReconcileResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminMaintenanceSmartReconcilePost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.apiAdminMaintenanceSmartReconcilePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminRefreshDynamicPathsPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BCCADMINBaseModelsDynamicPathRefreshResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminRefreshDynamicPathsPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.apiAdminRefreshDynamicPathsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminScanDynamicPathsPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BCCADMINBaseModelsDynamicPathScanResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminScanDynamicPathsPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.apiAdminScanDynamicPathsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminApi - factory interface
 */
export const AdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminApiFp(configuration)
    return {
        /**
         * 
         * @param {string} target 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminDeployedFilesRepairTargetPost(target: string, options?: RawAxiosRequestConfig): AxiosPromise<BCCADMINBaseModelsDeployedFileRepairResult> {
            return localVarFp.apiAdminDeployedFilesRepairTargetPost(target, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} target 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminDeployedFilesScanTargetPost(target: string, options?: RawAxiosRequestConfig): AxiosPromise<BCCADMINBaseModelsDeployedFileScanResult> {
            return localVarFp.apiAdminDeployedFilesScanTargetPost(target, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminDeploymentQueueForcePreviewPost(options?: RawAxiosRequestConfig): AxiosPromise<BCCADMINBaseModelsDeploymentQueueSeedResult> {
            return localVarFp.apiAdminDeploymentQueueForcePreviewPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminDeploymentQueueSeedPreviewPost(options?: RawAxiosRequestConfig): AxiosPromise<BCCADMINBaseModelsDeploymentQueueSeedResult> {
            return localVarFp.apiAdminDeploymentQueueSeedPreviewPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminLinksScanPost(options?: RawAxiosRequestConfig): AxiosPromise<BCCADMINBaseModelsBrokenLinkScanResult> {
            return localVarFp.apiAdminLinksScanPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminMaintenanceForceCategoryIdsPost(options?: RawAxiosRequestConfig): AxiosPromise<Array<BCCADMINBaseModelsReferenceIdForceResult>> {
            return localVarFp.apiAdminMaintenanceForceCategoryIdsPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminMaintenanceForceContentTypeIdsPost(options?: RawAxiosRequestConfig): AxiosPromise<Array<BCCADMINBaseModelsContentTypeIdForceResult>> {
            return localVarFp.apiAdminMaintenanceForceContentTypeIdsPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminMaintenanceForceReferenceDataIdsPost(options?: RawAxiosRequestConfig): AxiosPromise<BCCADMINBaseModelsReferenceIdForceReport> {
            return localVarFp.apiAdminMaintenanceForceReferenceDataIdsPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminMaintenanceForceTaxonomyIdsPost(options?: RawAxiosRequestConfig): AxiosPromise<Array<BCCADMINBaseModelsReferenceIdForceResult>> {
            return localVarFp.apiAdminMaintenanceForceTaxonomyIdsPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminMaintenanceHardCleanStatusGet(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiAdminMaintenanceHardCleanStatusGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} target 
         * @param {boolean} [purge] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminMaintenanceHardCleanTargetPost(target: string, purge?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiAdminMaintenanceHardCleanTargetPost(target, purge, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {boolean} [dryRun] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminMaintenanceMigrateBodiesPost(dryRun?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiAdminMaintenanceMigrateBodiesPost(dryRun, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminMaintenanceMigrateBodiesStatusGet(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiAdminMaintenanceMigrateBodiesStatusGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminMaintenancePruneDanglingReferenceRefsPost(options?: RawAxiosRequestConfig): AxiosPromise<BCCADMINBaseModelsDanglingReferencePruneResult> {
            return localVarFp.apiAdminMaintenancePruneDanglingReferenceRefsPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} target 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminMaintenanceRebakeFragmentsTargetPost(target: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiAdminMaintenanceRebakeFragmentsTargetPost(target, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {boolean} [pruneContentTypes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminMaintenanceReconcileReferenceDataPost(pruneContentTypes?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<BCCADMINServicesReferenceDataReferenceDataReconcileReport> {
            return localVarFp.apiAdminMaintenanceReconcileReferenceDataPost(pruneContentTypes, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminMaintenanceRetranslateAllPost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiAdminMaintenanceRetranslateAllPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminMaintenanceSmartReconcilePost(options?: RawAxiosRequestConfig): AxiosPromise<BCCADMINServicesServicesSmartReconcileResult> {
            return localVarFp.apiAdminMaintenanceSmartReconcilePost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminRefreshDynamicPathsPost(options?: RawAxiosRequestConfig): AxiosPromise<BCCADMINBaseModelsDynamicPathRefreshResult> {
            return localVarFp.apiAdminRefreshDynamicPathsPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminScanDynamicPathsPost(options?: RawAxiosRequestConfig): AxiosPromise<BCCADMINBaseModelsDynamicPathScanResult> {
            return localVarFp.apiAdminScanDynamicPathsPost(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminApi - object-oriented interface
 */
export class AdminApi extends BaseAPI {
    /**
     * 
     * @param {string} target 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAdminDeployedFilesRepairTargetPost(target: string, options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).apiAdminDeployedFilesRepairTargetPost(target, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} target 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAdminDeployedFilesScanTargetPost(target: string, options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).apiAdminDeployedFilesScanTargetPost(target, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAdminDeploymentQueueForcePreviewPost(options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).apiAdminDeploymentQueueForcePreviewPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAdminDeploymentQueueSeedPreviewPost(options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).apiAdminDeploymentQueueSeedPreviewPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAdminLinksScanPost(options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).apiAdminLinksScanPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAdminMaintenanceForceCategoryIdsPost(options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).apiAdminMaintenanceForceCategoryIdsPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAdminMaintenanceForceContentTypeIdsPost(options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).apiAdminMaintenanceForceContentTypeIdsPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAdminMaintenanceForceReferenceDataIdsPost(options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).apiAdminMaintenanceForceReferenceDataIdsPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAdminMaintenanceForceTaxonomyIdsPost(options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).apiAdminMaintenanceForceTaxonomyIdsPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAdminMaintenanceHardCleanStatusGet(options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).apiAdminMaintenanceHardCleanStatusGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} target 
     * @param {boolean} [purge] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAdminMaintenanceHardCleanTargetPost(target: string, purge?: boolean, options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).apiAdminMaintenanceHardCleanTargetPost(target, purge, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {boolean} [dryRun] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAdminMaintenanceMigrateBodiesPost(dryRun?: boolean, options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).apiAdminMaintenanceMigrateBodiesPost(dryRun, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAdminMaintenanceMigrateBodiesStatusGet(options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).apiAdminMaintenanceMigrateBodiesStatusGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAdminMaintenancePruneDanglingReferenceRefsPost(options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).apiAdminMaintenancePruneDanglingReferenceRefsPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} target 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAdminMaintenanceRebakeFragmentsTargetPost(target: string, options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).apiAdminMaintenanceRebakeFragmentsTargetPost(target, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {boolean} [pruneContentTypes] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAdminMaintenanceReconcileReferenceDataPost(pruneContentTypes?: boolean, options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).apiAdminMaintenanceReconcileReferenceDataPost(pruneContentTypes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAdminMaintenanceRetranslateAllPost(options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).apiAdminMaintenanceRetranslateAllPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAdminMaintenanceSmartReconcilePost(options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).apiAdminMaintenanceSmartReconcilePost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAdminRefreshDynamicPathsPost(options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).apiAdminRefreshDynamicPathsPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAdminScanDynamicPathsPost(options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).apiAdminScanDynamicPathsPost(options).then((request) => request(this.axios, this.basePath));
    }
}

